<template>
  <a class="btn" @click="handleClick">
    <slot></slot>
  </a>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "BaseButton",
  props: {
    onClick: {
      type: Function,
      default: () => {}
    }
  },
  methods: {
    handleClick(event) {
      this.onClick(event);
    }
  }
});
</script>

<style scoped>
.btn {
  display: inline-block;
  padding: 0.75em 1.5em;
  background-color: white;
  color: black;
  font-weight: 500;
  cursor: pointer;
  text-align: center;
  border-radius: 4px;
  text-decoration: none;
  transition: background-color 0.25s ease, color 0.25s ease;
  min-width: 150px;
}

.btn:hover,
.btn:focus {
  outline: none;
  background-color: #f7f7f7;
  transform: translateY(-2px);
  transition: transform 0.2s ease;
}

.btn:active {
  transform: scale(0.98);
}
</style> 